<template>
   <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      
      <vs-card>
        <div class="d-md-flex align-items-center pb-2">
        <h3 class="card-title mb-0">Input Pengiriman {{this.$route.params.ref}}</h3>
        <div class="ml-auto">
          <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
           Batal
          </vs-button>
        </div> 
        </div>
        <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
            <b>Terdapat Kesalahan..</b>
            <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </vs-alert>
          <div>
          <vs-row>
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
                <vs-input label="NO HP" class="w-100 mt-4" v-model="formdata.hp_pengirim"/>  
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="4">  
                <vs-input label="NAMA PENGIRIM" class="w-100 mt-4" v-model="formdata.nama_pengirim"/>  
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" vs-sm="4">  
                <vs-textarea label="ALAMAT PENGIRIM" ref="uraian" v-model.lazy="formdata.alamat_pengirim" class="mt-4 w-100" />
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
                <vs-input label="NO HP PENERIMA" class="w-100 mt-4" v-model="formdata.hp_penerima"/>  
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" vs-sm="4">  
                <vs-input label="NAMA PENERIMA" class="w-100 mt-4" v-model="formdata.nama_penerima"/>  
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="12" vs-xs="12" vs-sm="4">  
                <vs-textarea label="ALAMAT PENERIMA" ref="uraian" v-model.lazy="formdata.alamat_penerima" class="mt-4 w-100" />
            </vs-col>
          </vs-row>
          <vs-row>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="PROPINSI" v-model="formdata.prop_id">
              <vs-select-item
                :key="index"
                :value="item.prop_id"
                :text="item.prop_nama"
                v-for="(item,index) in optpropinsi"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="KABUPATEN" v-model="formdata.kab_id">
              <vs-select-item
                :key="index"
                :value="item.kab_id"
                :text="item.kab_nama"
                v-for="(item,index) in optkabupaten"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="KECAMATAN" v-model="formdata.kec_id">
              <vs-select-item
                :key="index"
                :value="item.kec_id"
                :text="item.kec_nama"
                v-for="(item,index) in optkecamatan"
              />
            </vs-select>
          </vs-col>
          </vs-row>
          <vs-row>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="PRODUK" v-model="formdata.kode_produk">
              <vs-select-item
                :key="index"
                :value="item.kode"
                :text="item.nama"
                v-for="(item,index) in optproduk"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
                <vs-input label="HARGA SATUAN" class="w-100 mt-4" v-model="formdata.harga"/>  
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
                <vs-input label="BERAT (KG)" class="w-100 mt-4" v-model="formdata.berat"/>  
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
                <vs-input label="TOTAL HARGA" class="w-100 mt-4" v-model="formdata.total_harga"/>  
          </vs-col>
          
          </vs-row>
          <vs-row>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">  
            <vs-select class="w-100 mt-4" label="PEMBAYARAN" v-model="formdata.bayar">
              <vs-select-item
                :key="index"
                :value="item.kode"
                :text="item.nama"
                v-for="(item,index) in optbayar"
              />
            </vs-select>
          </vs-col>
          </vs-row>
        </div>
        <hr class="custom-hr" />
        
       
        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>
    
   </vs-row>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { CurrencyDirective, parseCurrency, setValue } from 'vue-currency-input'
  import _ from 'lodash'

  export default {
    components: {
      DatePicker,
    },
    directives: {
        currency: CurrencyDirective
    },
    
    data: function () {
      return {
        // eslint-disable-next-line
        locale: 'de',
        currency: null,
        datetrans: '',
        formdata: {
            hp_pengirim:'',
            nama_pengirim:'',
            alamat_pengirim:'',
            hp_penerima:'',
            nama_penerima:'',
            alamat_penerima:'',
            prop_id:'',
            kab_id:'',
            kec_id:'',
            kode_produk:'REG',
            harga:'',
            total_harga:'',
            berat:'1',
            bayar:'CASH',
            office_id:this.$store.getters.getOffice,
            opr:'',
            datatrans:[],
            isEdit: false,
            prevReferensi:'',
            po_no:'',
            sj_no:''
        },
        optpropinsi:[],
        optkabupaten:[],
        optkecamatan:[],
        optproduk:[{'kode':'REG','nama':'REGULER'},{'kode':'EXP','nama':'EXPRESS'}],
        optbayar:[{'kode':'COD','nama':'COD'},{'kode':'CASH','nama':'CASH'}],
        kelompok:'',
        jenis:'',
        barang:'',
        satuan:'',
        qty:'',
        catatan:'',
        dk:true,
        transval:'',
        errors:[],
        errorPerkiraan:false,
        errorBarang:false,
        errorQty:false,
        numSumDebet:0,
        numSumKredit:0,
        idtrans:0,
        
        //formatTgl:''
      }
    },
    methods:{
        backpage: function(){
            this.$router.go(-1);
        },
        disabledBeforeYear(date) {
            return date.getFullYear() < window.$cookies.get('THN') || date.getFullYear() > window.$cookies.get('THN');
        },
        getAllData: function(){
            this.$http.get('/api/wilayahlist').then(response => {
                //console.log(response.data);
                this.optpropinsi = response.data
            }).catch(error=>{
                //console.log(error);
            });
            //edit mode init data
            if(this.$route.params.ref != null){
                this.formdata.isEdit = true
                this.$http.get(this.jurnalUrl+"/"+this.$route.params.ref).then(response => {
                    console.log(response.data)
                    this.formdata.datatrans = response.data;
                    const keys = Object.keys(response.data)
                    for(const key of keys){
                        let subkeys = Object.keys(response.data[key])
                        subkeys.forEach(item => {
                            if (this.formdata.hasOwnProperty(item))
                                this.formdata[item] = response.data[key][item]
                            if(item == 'bpbd'){
                                console.log('bpbd')
                                console.log(response.data[key][item].flat())
                                let objBpb = response.data[key][item]
                                /* var self = this
                                Object.keys(objBpb).forEach(key => {
                                    //console.log(key, objBpb[key]);
                                    self.formdata.datatrans = [...objBpb[key],objBpb[key].itembarang]
                                }); */

                                this.formdata.datatrans = [...response.data[key][item]]
                            }
                            if(item == 'datatrans'){
                                let arr = Object.values(response.data[key][item]);
                                console.log(arr)
                                let maxId = _.maxBy(arr, function(o) { return o.id; })
                                console.log(maxId)
                                //let min = Math.min(...arr);
                                //let max = Math.max(...arr);

                                this.idtrans = maxId.id
                            }
                                

                            if(item == 'bpb_no'){
                                this.formdata.referensi = response.data[key][item]   
                                this.formdata.prevReferensi = this.formdata.referensi
                            }
                            if(item == 'bpb_tgl'){
                                let tgldata = response.data[key][item]
                                let arrtgl = tgldata.split("-")
                                let d = new Date(arrtgl[0],arrtgl[1]-1,arrtgl[2])
                                let dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: '2-digit', day: '2-digit' }) 
                                let [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(d) 
                                //var tgltrans = `${day}-${month}-${year}`
                                this.datetrans = new Date(`${year},${month},${day}`)
                            }  
                            if(item == 'referensi')
                                this.formdata.prevReferensi = response.data[key][item]
                        })
                    }
                }).catch(error=>{
                    console.log(error)
                    this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
                });
            }
            //edit mode init data

            this.formdata.opr = this.$store.getters.getUserName
        },
        parseNama: function(nama){
            var parts = nama.split('+');
            return parts[0].replace(/=/g, '\u00a0') + parts[1];        
        },
       
        addTrans: function(){
            if(this.qty == ''){
                this.errorQty = true
            }
            else{
                this.errorQty = false
                if(this.barang!=''){
                    var self = this
                    let idjurnal = ++this.idtrans
                    let dataBarang = {}
                    let obj_barang = this.optbarang.find(x => x.kode_barang==self.barang)
                    let nama_barang = obj_barang.nama
                    let parts = nama_barang.split('+')
                    dataBarang.kode_barang = this.barang
                    dataBarang.nama_barang = parts[1]
                    dataBarang.item_id = obj_barang.item_id
                    dataBarang.qty_pesan = this.qty
                    dataBarang.satuan = this.satuan
                    dataBarang.catatan = this.catatan
                    dataBarang.referensi = this.formdata.referensi
                    dataBarang.rekanan = this.formdata.rekanan
                    dataBarang.tanggal = this.formdata.tanggal
                    dataBarang.opr = this.formdata.opr
                    dataBarang.id = idjurnal
                    this.formdata.datatrans.push(dataBarang)
                    this.clearTrans()
                } 
                else{
                    this.errorBarang = true
                    //this.setFocusOnInput('perkiraan');
                }   
            }
                     
        },
        removeTrans: function(id) {
            let index = this.formdata.datatrans.findIndex(x => x.id == id)
            this.formdata.datatrans.splice(index,1)
        },
        clearTrans: function(){
            this.qty = "";
            this.catatan = "",
            //this.barang = "";
            //this.setFocusOnInput('uraian');
            this.errorBarang = false;
        },
        setFocusOnInput(inputName) {
            /** 
            * @see https://vuejs.org/v2/api/#vm-el 
            * @see https://vuejs.org/v2/api/#vm-refs
            */
            // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
            let inputEl = this.$refs[inputName].$el.querySelector('input');
            //console.log(inputEl.focus) // <== See if `focus` method avaliable
            inputEl.focus() //  <== This time the focus will work properly
        },
        numberValue (value) {
            //alert(value)
            return parseCurrency(value.toString(), this.options)
        },
        hitungSelisih: function(){
            let jumlahDebet = this.numSumDebet
            let jumlahKredit = this.numSumKredit
            let selisih = 0;
            if(this.dk){ //debet transaksi
                if(jumlahDebet < jumlahKredit)
                selisih = jumlahKredit - jumlahDebet
            } 
            else{
                if(jumlahKredit < jumlahDebet)
                selisih = jumlahDebet - jumlahKredit
                //setValue(this.$refs.transval, selisih)
            }
            this.transval = new Intl.NumberFormat('de-DE',{notation: 'standard',}).format(selisih)
        },
        checkForm:function(e) {
            this.errors = [];
            //cek dari client dulu...
            if(this.formdata.nama_pengirim == ''){
                this.errors.push("Nama belum terisi...")
            }
            if(this.formdata.hp_pengirim == ''){
                this.errors.push("HP belum terisi...")
            }

            if(this.errors.length > 0){
                this.handleError(this.error,'local')
            }
            else{
                this.$vs.loading({'type':'radius'})
                this.$http.post('/api/kirim',{
                    formdata : this.formdata
                }).then(response => {
                    console.log(response);
                    this.handleSuccess();
                    //
                }).catch(error=>{
                    console.log(error.response)
                    this.handleError(error)
                })
            }
        },
        handleError: function(error,type=''){
            if(type != 'local'){
                if (error.response != null){
                    let status = error.response.status
                    console.log(status)
                    switch(status){
                        case 422 :
                            const keys = Object.keys(error.response.data.errors)
                            //console.log(keys);
                            for(const key of keys){
                                //console.log(key)
                                //console.log(error.response.data.errors[key][0])
                                this.errors.push(error.response.data.errors[key][0])
                            }
                        break
                        case 500 :
                            this.errors.push('Internal server error.. silahkan hubungi administrator')
                            break
                        default:
                            this.errors.push('Terjadi error di server..')
                            break
                    }
                }
                else
                    this.errors.push('Terjadi error di server..')
            }
            console.log('handle error')
            this.notify()
            this.$vs.loading.close()
        },
        handleSuccess: function(){
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            //this.$router.push('/jurnal/ju');
            this.$router.push({name : this.routeBack});
        },
        notify: function(){
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:()=>{
                    window.scrollTo(0,0);
                },
            })
        }
    },
    computed: {
        options () {
            return {
                locale: this.locale,
                currency: this.currency
            }
        }
    },
    watch:{
        'formdata.prop_id': function(){
            var self = this
            let arrKab = this.optpropinsi.filter(item => item.prop_id == self.formdata.prop_id)
            
            this.optkabupaten = arrKab.map(item => item.kabpropinsi).flat()
            //console.log(this.optkabupaten)
        },
        'formdata.kab_id': function(){
            var self = this
            let arrKab = this.optpropinsi.filter(item => item.prop_id == self.formdata.prop_id).map(item => item.kabpropinsi).flat()
            console.log(arrKab)
            let arrKec = arrKab.filter(item => item.kab_id == self.formdata.kab_id).map(item => item.kecamatankab).flat()
            this.optkecamatan = arrKec
            
        },
        'formdata.kec_id': function(){
            this.$http.post('/api/cekharga',{
                    fkab_id : this.$store.getters.getKabupaten,
                    dkab_id : this.formdata.kab_id,
                    dkec_id : this.formdata.kec_id,
                    kode_produk : this.formdata.kode_produk
            }).then(response => {
                this.formdata.harga = response.data
            }).catch(error=>{
                console.log(error)
            })
            
        },
        'formdata.kode_produk': function(){
            this.$http.post('/api/cekharga',{
                    fkab_id : this.$store.getters.getKabupaten,
                    dkab_id : this.formdata.kab_id,
                    dkec_id : this.formdata.kec_id,
                    kode_produk : this.formdata.kode_produk
            }).then(response => {
                this.formdata.harga = response.data
            }).catch(error=>{
                console.log(error)
            })
            
        },
        'formdata.berat': function(){
            var self = this
            let harga = this.formdata.harga
            let berat = this.formdata.berat
            let total = Number(harga)*Number(berat)
            this.formdata.total_harga = total
            
        },
        'formdata.harga': function(){
            var self = this
            let harga = this.formdata.harga
            let berat = this.formdata.berat
            let total = Number(harga)*Number(berat)
            this.formdata.total_harga = total
            
        },
    },
    mounted: function () {
        this.getAllData();
    },
  }
</script>